import React from 'react';

import { LTBox, LTTag, LTText, LTTooltip } from '@lambdatestincprivate/lt-components';
import { themeGet } from '@primer/react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  border-radius: 6px;
  border: 1px solid ${themeGet('colors.border.default')};
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 16px;
`;

const SectionVertical = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Dot = styled.span`
  display: inline-block;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: ${themeGet('colors.fg.disabled')};
`;

const ConfigurationListItem = styled.li`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const SectionHorizontal = styled(LTBox)`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const ConfigurationList = styled.ul`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const InlineWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
`;

const SecondaryHeader = ({ secondaryHeaderData = [], compact = false }) => {
  const WrapperComponent = compact ? InlineWrapper : Wrapper;
  const renderSecondaryHeaderValue = (value, isMultiValue, isCustomHTML) => {
    if (isCustomHTML) {
      return value;
    }
    if (isMultiValue) {
      return (
        <ConfigurationList>
          {value.map((item, index) => {
            const {
              tooltipLabel = '',
              value: itemValue = '',
              icon = '',
              id = '',
              dataTestId = '',
              renderAsTag = false,
            } = item || {};

            return (
              <>
                {(itemValue || icon) && (
                  <ConfigurationListItem>
                    <LTTooltip text={tooltipLabel}>
                      <SectionHorizontal id={id}>
                        {icon}
                        {renderAsTag ? (
                          <LTTag text={itemValue} variant={LTTag.Variant.SECONDARY} />
                        ) : (
                          <LTText variant={LTText.TextVariant.SUBHEADER_BOLD}>
                            {itemValue}
                          </LTText>
                        )}
                      </SectionHorizontal>
                    </LTTooltip>
                    {index !== value.length - 1 && <Dot />}
                  </ConfigurationListItem>
                )}
              </>
            );
          })}
        </ConfigurationList>
      );
    }
    return <LTText variant={LTText.TextVariant.SUBHEADER_BOLD}>{value}</LTText>;
  };

  return (
    <WrapperComponent>
      {secondaryHeaderData.map((item) => {
        const {
          label = '',
          labelId = '',
          labelTooltip = '',
          isCustomHTML = false,
          value = '',
          isMultiValue = false,
        } = item || {};

        const labelContent = (
          <LTText
            variant={LTText.TextVariant.SUBHEADER_REGULAR}
            color="fg.muted"
          >
            {label}
          </LTText>
        );

        return (
          <>
            <SectionVertical id={labelId}>
              {labelTooltip ? (
                <LTTooltip text={labelTooltip}>{labelContent}</LTTooltip>
              ) : (
                labelContent
              )}
              {renderSecondaryHeaderValue(value, isMultiValue, isCustomHTML)}
            </SectionVertical>
          </>
        );
      })}
    </WrapperComponent>
  );
};

export default SecondaryHeader;
